import { Component } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { SemCallsV5Component } from '../sem-calls-v5/sem-calls-v5.component';
import * as _ from 'underscore';

@Component({
	selector: 'app-sem-calls-v4',
	templateUrl: './sem-calls-v4.component.html',
	styleUrls: ['./sem-calls-v4.component.css']
})
export class SemCallsV4Component extends SemCallsV5Component {
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	filterChange(value: any) {
		this.selectedValue = value;
		super.filterChange(value);
	}
}
